import React, { Component } from 'react'
import {Row} from 'antd'
import ShipTimeLine from './ShipTimeline'

export default class ShipStatus extends Component {
    render(){
        return( 
            <Row align='middle' justify='center'>
                {/* <Image src='./ofrp.webp' width={700} style={{align:'center'}}/> */}
                {this.props.shipNum && this.props.shipNum.includes("CVN")? <ShipTimeLine key={this.props.shipNum} shipEvents={this.props.shipEvents}/>:null}
            </Row>
        )
    }
}